// Masifi: auto-recuperación ante fallo de carga de un chunk JS.
// Tras un deploy cambian los hashes de los bundles; un navegador con el shell
// viejo cacheado puede pedir un chunk que ya no existe → la carga diferida (lazy
// import de una ruta/componente) falla y la app queda en pantalla blanca.
// Recargamos UNA vez para traer el shell nuevo. Guard anti-loop por sessionStorage.
const RELOAD_GUARD_KEY = 'masifi:chunk-reload-at';
const RELOAD_COOLDOWN_MS = 10000;

const reloadOnce = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return; // ya recargamos → evita loop
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch (error) {
    // sessionStorage no disponible (modo privado, etc.): recargar una vez igual.
  }
  window.location.reload();
};

const isChunkLoadError = message =>
  /dynamically imported module|Importing a module script failed|Loading chunk|error loading dynamically imported|Failed to fetch dynamically/i.test(
    message || ''
  );

export const installChunkReload = () => {
  if (typeof window === 'undefined') return;

  // Vite dispara este evento cuando falla el preload de un módulo dinámico.
  window.addEventListener('vite:preloadError', event => {
    event.preventDefault();
    reloadOnce();
  });

  // Respaldo: el import dinámico fallido burbujea como promesa no manejada.
  window.addEventListener('unhandledrejection', event => {
    if (isChunkLoadError(event?.reason?.message)) reloadOnce();
  });
};
